export default __webpack_public_path__ + "static/media/PARED2_Mesa de trabajo 1 - copia.4d17f925.jpg";